const version = {
    name: 'v1.0',
    domain: 'localhost',
}

export default version